(() => {
    'use strict';

    if (!real.dom.$body.hasClass('workspace-user-notifications')) {
        return;
    }

    const whatsNewHiddenInput = $('#whats-new-email-delivery-policy-never-hidden-input');
    const whatsNewSelect = $('#whats-new-email-notification-select');
    $('#whats-new-email-notifications-toggle-button').on('change', e => {
        if (e.target.checked) {
            whatsNewHiddenInput.removeAttr('name');
            whatsNewSelect.attr('name', 'whats_new_email_delivery_policy');
        } else {
            whatsNewSelect.removeAttr('name');
            whatsNewHiddenInput.attr('name', 'whats_new_email_delivery_policy');
        }
    });

    $('#save-btn').on('click', e => {
        const btn = $(e.target);
        const container = $('#notification-settings');
        const dataPayload = real.form.getDataPayload(container);
        const hash = container.data('hash');
        const userEmail = encodeURIComponent(container.data('user-email'));

        if (!hash || !userEmail) {
            return;
        }

        real.button.loading(btn);

        real.ajax.json(`${real.baseUri}/2/notifications/${hash}/${userEmail}`, {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success: function () {
                real.button.reset(btn);
                real.notification.show(howspace.translate('whatsnew_settings_saved_successfully'), 'success');
            },
            error: function () {
                real.button.reset(btn);
                real.notification.show(howspace.translate('whatsnew_settings_saved_error'), 'danger');
            }
        });
    });
})();
